import { z } from 'zod';
// Pagination request parameters
export const PaginationDTOSchema = z.union([
    z.object({
        limit: z.coerce.number().int().min(1).max(100),
        cursor: z.undefined(),
        direction: z.undefined(),
    }),
    z.object({
        limit: z.coerce.number().int().min(1).max(100),
        cursor: z.string().min(1),
        direction: z.enum(['forward', 'backward']),
    }),
]);
// Cursor encoding/decoding utilities
export const CursorUtils = {
    encode: (data) => {
        return Buffer.from(JSON.stringify(data)).toString('base64');
    },
    decode: (cursor) => {
        try {
            return JSON.parse(Buffer.from(cursor, 'base64').toString('utf-8'));
        }
        catch {
            throw new Error('Invalid cursor format');
        }
    },
    // Create a cursor from a timestamp and id (common pattern)
    fromTimestampAndId: (timestamp, id) => {
        return CursorUtils.encode({ t: timestamp.toISOString(), id });
    },
    // Parse a cursor expecting timestamp and id
    toTimestampAndId: (cursor) => {
        const decoded = CursorUtils.decode(cursor);
        if (typeof decoded.t !== 'string' || typeof decoded.id !== 'string') {
            throw new Error('Invalid cursor structure');
        }
        return {
            timestamp: new Date(decoded.t),
            id: decoded.id,
        };
    },
};
// Helper to create a paginated query schema that merges PaginationDTOSchema with domain-specific filters
export function createPaginatedQuerySchema(filterSchema) {
    return z.union([
        z
            .object({
            limit: z.coerce.number().int().min(1).max(100),
            cursor: z.undefined(),
            direction: z.undefined(),
        })
            .merge(filterSchema),
        z
            .object({
            limit: z.coerce.number().int().min(1).max(100),
            cursor: z.string().min(1),
            direction: z.enum(['forward', 'backward']),
        })
            .merge(filterSchema),
    ]);
}
// Helper to build pagination response
export function buildPaginatedResponse(result, mapper, cursorExtractor) {
    const data = result.items.map(mapper);
    const meta = {
        hasMore: result.hasMore,
    };
    if (result.firstItem) {
        meta.previousCursor = cursorExtractor(result.firstItem);
    }
    if (result.lastItem) {
        meta.nextCursor = cursorExtractor(result.lastItem);
    }
    return { data, meta };
}
//# sourceMappingURL=pagination.js.map